export const EMAIL_TYPE = 'e-mail';
export const SMS_TYPE = 'sms';
export const INTERNAL_TYPE = 'internal';
